export class AccordionModel {
 id: any;
 isActive: boolean;
 category: any;
 description: any;
 ariaLabel?: any;
}
